module.exports = __webpack_public_path__ + "static/img/introduceBTypeAIcon2.d279d25.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/introduceBTypeAIcon2.png
// module id = R3U3
// module chunks = 0